import loanFormModel from '../../components/loan_application/form_models/loanFormModel';
import { defaultBorrowerLegalName } from '../../components/loan_application/form_models/constants';
import { genericRequiredFieldError } from '../../constants';
import { LoanApplication, type PROJECT_TYPE } from '../../modules/loan';
import { ValidationSchema } from '../interfaces';
import { Validation } from '../Validation';

const {
  formField: {
    projectType,
    systemPowerSingleOrMultipleUsers,
    systemPowerCommunityOrPPALease,
    systemPowerLegalNamesOfOfftakers,
  },
} = loanFormModel;

export class LegalNamesOfOfftakersValidation implements ValidationSchema {
  public name: string = systemPowerLegalNamesOfOfftakers.name;
  public label: string = systemPowerLegalNamesOfOfftakers.getLabel(
    defaultBorrowerLegalName,
    false
  );
  public dependsOn: string[] = [
    projectType.name,
    systemPowerSingleOrMultipleUsers.name,
    systemPowerCommunityOrPPALease.name,
  ];
  public type = 'string';
  public required = {
    message: '',
    value: false,
  };
  public nullable = true;

  when(
    projectType: string,
    singleOrMultipleUsers: string,
    communityOrPPALease: string,
    schema
  ) {
    if (!projectType || !LoanApplication.isSolar(projectType as PROJECT_TYPE))
      return schema;
    if (
      singleOrMultipleUsers === 'Multiple Users' &&
      communityOrPPALease === 'PPA/Lease Agreement'
    ) {
      return schema
        .required(genericRequiredFieldError)
        .nullable()
        .test(
          'are-legal-names-filled',
          'Please enter a legal name for each Offtaker.',
          (value) => {
            const offtakerNames = value?.split('\n') || [];
            if (offtakerNames.length === 0) {
              return false;
            }
            return offtakerNames.every((name) => name.length > 0);
          }
        );
    } else if (singleOrMultipleUsers === 'Single User') {
      return schema.required(genericRequiredFieldError);
    }
    return schema;
  }
}
export default new Validation(new LegalNamesOfOfftakersValidation());
